
import React from 'react'
import { Helmet } from 'react-helmet-async'

const Head = ({
  microcopy
}) => (
  <Helmet
    defaultTitle={ microcopy.text('head.title') }
    titleTemplate={ `%s - ${ microcopy.text('head.title') }`}
  >
    <html lang={ microcopy.code } />
    <meta name="description" content={ microcopy.text('head.description') } />
    <meta name="keywords" content={ microcopy.text('head.keywords') } />
    <link rel="icon" href="/favicon.ico" type="image/x-icon" />
  </Helmet>
)

export default Head